import gql from "graphql-tag";

// Apply for affiliate mutation
export const APPLY_FOR_AFFILIATE = gql`
  mutation ApplyForAffiliate($applicationNotes: String) {
    applyForAffiliate(applicationNotes: $applicationNotes) {
      id
      referralCode
      status
      commissionAmount
      applicationNotes
      createdAt
    }
  }
`;

export interface ApplyForAffiliateVariables {
  applicationNotes?: string;
}

export interface ApplyForAffiliateResponse {
  applyForAffiliate: {
    id: string;
    referralCode: string;
    status: string;
    commissionAmount: number;
    applicationNotes?: string;
    createdAt: string;
  };
}

// Approve affiliate mutation
export const APPROVE_AFFILIATE = gql`
  mutation ApproveAffiliate($id: ID!) {
    approveAffiliate(id: $id) {
      id
      status
      commissionAmount
      approvedAt
    }
  }
`;

export interface ApproveAffiliateVariables {
  id: string;
}

// Update affiliate profile
export const UPDATE_AFFILIATE_PROFILE_MUTATION = gql`
  mutation UpdateAffiliateProfile($input: AffiliateProfileInput!) {
    updateAffiliateProfile(input: $input) {
      _id
      status
      message
    }
  }
`;

export interface ApproveAffiliateResponse {
  approveAffiliate: {
    id: string;
    status: string;
    commissionAmount: number;
    approvedAt: string;
  };
}

// Suspend affiliate mutation
export const SUSPEND_AFFILIATE = gql`
  mutation SuspendAffiliate($id: ID!, $reason: String!) {
    suspendAffiliate(id: $id, reason: $reason) {
      id
      status
      suspendedAt
      suspendedReason
    }
  }
`;

export interface SuspendAffiliateVariables {
  id: string;
  reason: string;
}

export interface SuspendAffiliateResponse {
  suspendAffiliate: {
    id: string;
    status: string;
    suspendedAt: string;
    suspendedReason: string;
  };
}

// Delete affiliate mutation
export const DELETE_AFFILIATE = gql`
  mutation DeleteAffiliate($affiliateId: ID!) {
    deleteAffiliate(affiliateId: $affiliateId) {
      _id
      status
      message
    }
  }
`;

export interface DeleteAffiliateVariables {
  affiliateId: string;
}

export interface DeleteAffiliateResponse {
  deleteAffiliate: {
    _id: string;
    status: string;
    message: string;
  };
}

// Bulk approve affiliates
export const BULK_APPROVE_AFFILIATES = gql`
  mutation BulkApproveAffiliates($affiliateIds: [ID!]!) {
    bulkApproveAffiliates(affiliateIds: $affiliateIds) {
      status
      message
      count
    }
  }
`;

export interface BulkApproveAffiliatesVariables {
  affiliateIds: string[];
}

export interface BulkApproveAffiliatesResponse {
  bulkApproveAffiliates: {
    status: string;
    message: string;
    count: number;
  };
}

// Bulk suspend affiliates
export const BULK_SUSPEND_AFFILIATES = gql`
  mutation BulkSuspendAffiliates($affiliateIds: [ID!]!, $reason: String!) {
    bulkSuspendAffiliates(affiliateIds: $affiliateIds, reason: $reason) {
      status
      message
      count
    }
  }
`;

export interface BulkSuspendAffiliatesVariables {
  affiliateIds: string[];
  reason: string;
}

export interface BulkSuspendAffiliatesResponse {
  bulkSuspendAffiliates: {
    status: string;
    message: string;
    count: number;
  };
}
